// TODO: Remove default deductible when backend is updated (see useCurrentContract)
const DEFAULT_DEDUCTIBLE = 250;

const NOMAD_INSURANCE_PRODUCT = 'NOMAD_INSURANCE';

export const findOngoingNomadInsuranceContract = (contracts, today = new Date()) => {
  const day = today.toISOString().slice(0, 10);

  return (
    (contracts ?? [])
      .filter((contract) => contract.product === NOMAD_INSURANCE_PRODUCT)
      .filter(
        (contract) =>
          contract.startDate <= day && (!contract.endDate || contract.endDate >= day)
      )
      .sort((a, b) => (a.startDate < b.startDate ? 1 : -1))[0] || null
  );
};

export const findPolicyForContract = (policies = [], contract) => {
  if (!contract || contract.insuranceProvider !== 'SAFETYWING') return null;

  const contractDate = contract.created || contract.startDate;
  const deductible = contract.deductible ?? DEFAULT_DEDUCTIBLE;

  const sortedPolicies = [...policies].sort(
    (a, b) => new Date(b.fields.effectiveDate) - new Date(a.fields.effectiveDate)
  );

  return (
    sortedPolicies.find((policy) => {
      if (policy.fields.planId) {
        return contract.standalonePlanId === policy.fields.planId;
      }

      if (!contractDate) return false;

      return (
        new Date(policy.fields.effectiveDate) < new Date(contractDate) &&
        deductible === policy.fields.deductible
      );
    }) || null
  );
};
